/**
 * @generated SignedSource<<327ab57edf0b9b2d081bce3432d34ed2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useRentalUnlocksRelayQuery$variables = {
  id: string;
};
export type useRentalUnlocksRelayQuery$data = {
  readonly getRental: {
    readonly id: string;
    readonly unlockableHardware: ReadonlyArray<{
      readonly hardwareType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly label: string | null | undefined;
      readonly number: number | null | undefined;
      readonly oldId: string | null | undefined;
    }> | null | undefined;
    readonly unlocks: ReadonlyArray<any> | null | undefined;
    readonly unlocksSuccessRate: number | null | undefined;
  } | null | undefined;
};
export type useRentalUnlocksRelayQuery = {
  response: useRentalUnlocksRelayQuery$data;
  variables: useRentalUnlocksRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Rental",
    "kind": "LinkedField",
    "name": "getRental",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unlocks",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unlocksSuccessRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "unlockableHardware",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareType",
            "kind": "LinkedField",
            "name": "hardwareType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRentalUnlocksRelayQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRentalUnlocksRelayQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8b61ab7aadbcb01ec2a9b3d0ba3f6c87",
    "id": null,
    "metadata": {},
    "name": "useRentalUnlocksRelayQuery",
    "operationKind": "query",
    "text": "query useRentalUnlocksRelayQuery(\n  $id: ID!\n) {\n  getRental(id: $id) {\n    id\n    unlocks\n    unlocksSuccessRate\n    unlockableHardware {\n      id\n      oldId\n      number\n      label\n      hardwareType {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "15f8e7b8715def1fbef0a70a48ec08df";

export default node;
